import { FC, useEffect, useState } from "react";
import { StyledCompleteJobDetails } from "./CompleteJobDetails.styles";
import { Col, Container, Row } from "react-grid-system";
import { InspectionToolSet } from "../../types/IInspectionToolSet";
import { LabelText } from "../Modals/CompleteJobModal/CompleteJobModal.styles";
import { useAuth } from "../../utility/useAuth";
import { DataManager, Query } from "@syncfusion/ej2-data";
import {
  getInspectionReasons,
  getInspectionToolSets,
  getJobInspectionLogs,
} from "../../services/ApiService";
import {
  ChangeEventArgs,
  ComboBoxComponent,
  DropDownListComponent,
  Inject,
} from "@syncfusion/ej2-react-dropdowns";
import { ToastUtility } from "@syncfusion/ej2-react-notifications";
import { InspectionStatus } from "../../types/InspectionStatus";
import { InspectionLog } from "../../types/InspectionLog";
import {
  ColumnDirective,
  ColumnsDirective,
  Edit,
  EditEventArgs,
  EditSettingsModel,
  GridComponent,
  IEditCell,
  Resize,
} from "@syncfusion/ej2-react-grids";
import { CheckBoxComponent } from "@syncfusion/ej2-react-buttons";
import { IUserInfo } from "../../types/IUserInfo";

interface ICompleteJobDetails {
  jobNumber: string;
  operation: string;
  qtyOrdered: number;
  userCode: string;
  onValidate: (
    inspectionToolSet: InspectionToolSet | undefined,
    reason: string | undefined,
    operationStatus: string | undefined,
    inspectionLogs: InspectionLog[] | undefined,
  ) => void;
}

export const CompleteJobDetails: FC<ICompleteJobDetails> = ({
  jobNumber,
  operation,
  qtyOrdered,
  userCode,
  onValidate,
}) => {
  const [inspectionToolSet, setInspectionToolSet] =
    useState<InspectionToolSet>();
  const [station, setStation] = useState<string>();
  const [inspectionToolSets, setInspectionToolSets] =
    useState<InspectionToolSet[]>();
  const [inspectionAcceptedReasons, setInspectionAcceptedReasons] =
    useState<string[]>();
  const [inspectionAcceptedReason, setInspectionAcceptedReason] =
    useState<string>();
  const [inspectionRejectedReasons, setInspectionRejectedReasons] =
    useState<string[]>();

  const [inspectionLogs, setInspectionLogs] = useState<InspectionLog[]>();

  let grid: GridComponent | null;

  const auth = useAuth();

  useEffect(() => {
    if (operation) {
      getInspectionToolSets(auth, operation)
        .then((toolSets) => {
          setInspectionToolSets(toolSets);
        })
        .catch((error) => {
          const message = `Failed to get inspection toolsets. Error: ${error}`;
          console.error(`Failed to get inspection toolsets. Error: ${error}`);
          ToastUtility.show(message, "Error", 2000);
        });
      getInspectionReasons(auth, operation, InspectionStatus.Accepted)
        .then((reasons) => {
          setInspectionAcceptedReasons(reasons);
        })
        .catch((error) => {
          const message = `Failed to get inspection reasons to accept. Error: ${error}`;
          console.error(message);
          ToastUtility.show(message, "Error", 2000);
        });
      getInspectionReasons(auth, operation, InspectionStatus.Rejected)
        .then((reasons) => {
          setInspectionRejectedReasons(reasons);
          rejectionReasonParams = {
            params: {
              actionComplete: () => false,
              dataSource: reasons, //new DataManager(reasons?.map((r)=>{return {key: r, value: r }})),
              //fields: { text: "key", value: "value" },
              query: new Query(),
            },
          };
        })
        .catch((error) => {
          const message = `Failed to get inspection reasons to reject. Error: ${error}`;
          console.error(message);
          ToastUtility.show(message, "Error", 2000);
        });
      getJobInspectionLogs(auth, jobNumber, InspectionStatus.Rejected).then(
        (result) => {
          if (result && result.length > 0) {
            const logs = result.map((log) => {
              log.rework = true;
              return log;
            });
            setInspectionLogs(logs);
          } else {
            let logs: InspectionLog[] = [];
            for (let i = 0; i < qtyOrdered; i++) {
              logs.push({
                id: undefined,
                job: jobNumber,
                operation: operation,
                line: i,
                associate: userCode,
                weldId: `${jobNumber}-${i}`,
                dateCreated: new Date(),
                status: InspectionStatus[InspectionStatus.Accepted],
                isAccepted: true,
                comment: "",
                rework: false,
                note: undefined,
                rejectionReason: undefined,
              });
            }
            setInspectionLogs(logs);
          }
        },
      );
    }
  }, [operation]);

  useEffect(() => {
    console.log(
      `onValidate ${inspectionToolSet} ${JSON.stringify(inspectionLogs)}`,
    );
    validate(inspectionToolSet, inspectionLogs);
  }, [inspectionToolSet, inspectionLogs]);

  function valueTemplate(data: any): JSX.Element {
    return (
      <span
        style={{
          color: data.colour.replace("#FF", "#").toLowerCase(),
        }}
      >
        {data.name}
      </span>
    );
  }

  function itemTemplate(data: any): JSX.Element {
    return (
      <Row align="stretch">
        <Col>
          <span
          // style={{
          //   color: data.colour.replace("#FF", "#").toLowerCase(),
          // }}
          >
            {data.name}
          </span>
        </Col>
        <Col>
          <div
            style={{
              borderStyle: "solid",
              backgroundColor: data.colour.replace("#FF", "#").toLowerCase(),
              minWidth: 100,
              height: 20,
            }}
          ></div>
        </Col>
      </Row>
    );
  }

  function onToolSetChange(args: any) {
    if (args && inspectionToolSets?.length) {
      const toolSet = inspectionToolSets.find(
        (tool) => tool.name === args.value,
      );
      setInspectionToolSet(toolSet);
    }
  }

  function onAcceptedReasonChange(args: any) {
    if (args) {
      setInspectionAcceptedReason(args.value);
      const logs = inspectionLogs?.map((log) => {
        log.note = args.value;
        log.comment = `${args.value} ${log.rejectionReason}`;
        return log;
      });

      console.log(
        `Reason changed: ${args.value} Update logs: ${JSON.stringify(logs)}`,
      );

      setInspectionLogs(logs);
      grid?.refresh();
    }
  }

  function onRejectedReasonChange(key: string, args: any) {
    if (args) {
      console.log(`Rejected Reason changed: ${args} ${args.value as string}`);

      const logs = inspectionLogs?.map((log) => {
        if (log.weldId === key) {
          log.rejectionReason = args.value;
          log.comment = `${log.note} ${log.rejectionReason}`;
        }

        return log;
      });

      setInspectionLogs(logs);
      //grid?.refresh();
    }
  }

  const editOptions: EditSettingsModel = {
    allowEditing: true,
    allowAdding: false,
    allowDeleting: false,
    mode: "Normal",
  };

  let rejectionReasonParams: IEditCell = {
    params: {
      actionComplete: () => false,
      dataSource: inspectionRejectedReasons, //new DataManager(country/*inspectionRejectedReasons?.map((r)=>{return {key: r, value: r }})*/),
      //fields: { text: "key", value: "value" },
      query: new Query(),
    },
  };

  const comboBoxTemplate = (props: any) => {
    return (
      <div>
        <ComboBoxComponent
          enabled={!props.isAccepted}
          value={props.rejectionReason}
          allowCustom={true}
          width="150"
          dataSource={inspectionRejectedReasons}
          popupHeight="150"
          popupWidth="200"
          change={(args: any) => {
            onRejectedReasonChange(props.weldId, args);
          }}
        ></ComboBoxComponent>
      </div>
    );
  };

  const checkBoxTemplate = (props: any) => {
    return (
      <div>
        <CheckBoxComponent
          checked={props.status === InspectionStatus[InspectionStatus.Accepted]}
          onChange={(args: any) => {
            if (inspectionLogs) {
              const logs = [
                ...inspectionLogs.map((item) => {
                  if (item.weldId === props.weldId) {
                    item.isAccepted = args.target.checked;
                    item.status = args.target.checked
                      ? InspectionStatus[InspectionStatus.Accepted]
                      : InspectionStatus[InspectionStatus.Rejected];
                  }
                  return item;
                }),
              ];
              setInspectionLogs(logs);
              validate(inspectionToolSet, logs);
            }
          }}
        />
      </div>
    );
  };

  const save = () => {
    (grid as GridComponent).editModule.batchSave();
  };

  const validate = (
    inspectionToolSet: InspectionToolSet | undefined,
    inspectionLogs: InspectionLog[] | undefined,
  ) => {
    console.log(
      `onValidate ${inspectionToolSet} ${JSON.stringify(inspectionLogs)}`,
    );
    let operationStatus: string | undefined;
    if (inspectionLogs) {
      operationStatus = inspectionLogs.some((log) => !log.isAccepted)
        ? InspectionStatus[InspectionStatus.Rejected]
        : InspectionStatus[InspectionStatus.Accepted];
    }

    onValidate(
      inspectionToolSet,
      inspectionAcceptedReason,
      operationStatus,
      inspectionLogs,
    );
  };

  const onActionComplete = (args: EditEventArgs) => {
    if (args.requestType === "refresh" || args.requestType === "save") {
      validate(inspectionToolSet, inspectionLogs);
    }
  };

  return (
    <StyledCompleteJobDetails>
      {/* <Container fluid> */}
      <Row align="stretch">
        <Col sm={4}>
          <LabelText>Select inspection tool set:</LabelText>
        </Col>
        <Col>
          <DropDownListComponent
            dataSource={inspectionToolSets}
            fields={{ text: "name", value: "name" }}
            valueTemplate={itemTemplate}
            itemTemplate={itemTemplate}
            value={station}
            change={onToolSetChange}
          />
        </Col>
      </Row>
      <Row align="stretch">
        <Col sm={4}>
          <LabelText>Inspection Notes:</LabelText>
        </Col>
        <Col>
          <ComboBoxComponent
            dataSource={inspectionAcceptedReasons}
            value={inspectionAcceptedReason}
            change={onAcceptedReasonChange}
          />
        </Col>
      </Row>
      <Row align="stretch">
        <GridComponent
          id="Grid"
          dataSource={inspectionLogs}
          //editSettings={editOptions}
          allowResizing
          gridLines="Both"
          ref={(g: GridComponent) => (grid = g)}
          actionComplete={onActionComplete}
          cellSaved={save}
          height={320}
        >
          <Inject services={[Resize]} />
          <ColumnsDirective>
            <ColumnDirective
              field="weldId"
              isPrimaryKey={true}
              headerText="Weld Id"
              width="100"
              textAlign="Left"
              allowEditing={false}
            />
            <ColumnDirective
              field="line"
              width="80"
              headerText="Line"
              textAlign="Right"
              allowEditing={false}
            />
            <ColumnDirective
              field="isAccepted"
              width="100"
              headerText="Accepted"
              textAlign="Right"
              type="boolean"
              //displayAsCheckBox={true}
              template={checkBoxTemplate}
              //editType="booleanedit"
            />
            <ColumnDirective
              field="note"
              headerText="Inspection Note"
              textAlign="Left"
              allowEditing={false}
            />
            <ColumnDirective
              field="rejectionReason"
              headerText="Rejection Reason"
              textAlign="Left"
              template={comboBoxTemplate}
              allowEditing={false}
              //editType="dropdownedit"
              //edit={rejectionReasonParams}
            />
          </ColumnsDirective>
          <Inject services={[Edit, Resize]} />
        </GridComponent>
      </Row>
      {/* </Container> */}
    </StyledCompleteJobDetails>
  );
};
